import React from 'react';
import PropTypes from 'prop-types';

const Lock = props => {
  return (
    <svg
      width="476"
      height="634"
      viewBox="0 0 476 634"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M396.509 317V159.02C396.509 71.7146 325.849 0.519531 238.045 0.519531C150.76 0.519531 79.5812 71.1949 79.5812 159.02V317H0.609131V634H476V317H396.509ZM159.073 159.02C159.073 115.367 194.402 80.0294 238.045 80.0294C281.687 80.0294 317.017 115.367 317.017 159.02V317H158.553V159.02H159.073Z"
        fill={props.color}
      />
      <path
        d="M136.212 419.414C114.878 419.414 97.285 437.011 97.285 458.35C97.285 479.689 114.878 497.286 136.212 497.286C157.547 497.286 175.14 479.689 175.14 458.35C175.14 437.011 157.547 419.414 136.212 419.414ZM121.704 473.421C121.704 475.988 122.197 478.587 123.209 480.871C115.366 476.278 110.196 467.659 110.196 457.831C110.196 443.312 122.217 431.288 136.732 431.288C151.235 431.288 163.25 443.294 163.268 457.797C162.849 464.014 161.079 469.154 157.994 473.267C157.909 463.429 149.702 455.272 139.849 455.272C129.945 455.272 121.704 463.515 121.704 473.421Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M338.838 419.414C317.503 419.414 299.911 437.011 299.911 458.35C299.911 479.689 317.503 497.286 338.838 497.286C360.173 497.286 377.765 479.689 377.765 458.35C377.765 437.02 360.701 419.414 338.838 419.414ZM365.894 457.811C365.433 469.175 359.242 478.025 350.303 482.209C351.719 479.55 352.307 476.608 352.307 473.421C352.307 463.515 344.067 455.272 334.162 455.272C325.177 455.272 317.56 462.056 316.224 470.712C314.122 466.874 312.821 462.674 312.821 457.831C312.821 443.312 324.843 431.288 339.358 431.288C353.866 431.288 365.883 443.301 365.894 457.811Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M186.127 392.519L186.083 392.501L186.037 392.486C155.902 382.612 125.764 373.775 95.1058 365.977C93.3003 365.296 91.4165 365.699 89.9693 366.583C88.5407 367.456 87.3586 368.903 86.9713 370.618C86.3057 372.414 86.7086 374.286 87.5882 375.726C88.4785 377.183 89.9648 378.384 91.7249 378.747C121.706 385.986 151.692 394.772 181.171 404.593C182.046 405.287 182.952 405.286 183.45 405.285C183.464 405.285 183.478 405.285 183.492 405.285C186.6 405.285 189.347 403.433 190.11 401.142C190.747 399.232 190.609 397.389 189.834 395.839C189.068 394.306 187.728 393.159 186.127 392.519Z"
        fill="white"
        stroke="white"
        strokeWidth="3"
      />
      <path
        d="M287.447 391.969L287.405 391.983L287.365 391.999C284.127 393.294 282.064 397.17 283.375 400.61C284.105 403.323 286.765 405.285 289.48 405.285C289.489 405.285 289.498 405.285 289.507 405.285C289.786 405.285 290.287 405.286 290.882 405.048C291.378 404.849 291.855 404.523 292.354 404.062C321.822 394.246 351.797 385.463 381.767 378.227C383.58 377.853 384.936 376.6 385.74 375.152C386.547 373.699 386.884 371.909 386.549 370.232C386.183 368.403 384.925 367.036 383.469 366.227C382.016 365.419 380.227 365.082 378.549 365.418L378.511 365.425L378.474 365.435C347.79 373.237 317.101 382.082 287.447 391.969Z"
        fill="white"
        stroke="white"
        strokeWidth="3"
      />
      <path
        d="M106.126 526.874L106.113 526.861L106.1 526.848C103.436 524.183 99.3688 524.183 96.7048 526.848C94.0453 529.508 94.041 533.567 96.6918 536.231C107.878 547.948 151.906 586.053 248.956 586.053C300.66 586.053 335.999 572.859 358.641 559.204C369.957 552.38 378.09 545.449 383.503 540.01C386.21 537.29 388.238 534.942 389.647 533.164C390.98 531.48 391.809 530.243 392.106 529.675C393.988 526.491 393.412 522.43 390.007 520.386C386.817 518.472 382.727 519.038 380.675 522.46L380.461 522.816V522.876C380.419 522.942 380.366 523.023 380.3 523.12C380.046 523.495 379.645 524.041 379.086 524.737C377.972 526.126 376.258 528.081 373.894 530.413C369.167 535.077 361.857 541.238 351.575 547.409L351.565 547.415L351.555 547.421C332.569 559.226 299.592 572.659 248.956 572.659C156.391 572.659 116.251 537.508 106.126 526.874Z"
        fill="white"
        stroke="white"
        strokeWidth="3"
      />
    </svg>
  );
};

Lock.defaultProps = {
  color: '#9B4CEE',
};

Lock.propTypes = {
  color: PropTypes.string,
};

export default Lock;
